import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { organizationI } from 'app/core/interfaces/organization';
import Organization from 'app/core/models/Organization';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  public create(params: any) {
    return this.http.post(
      `${environment.apiUrl}/secretarias-location`,
      params,
      { headers: this.getHeaders() }
    );
  }

  public update(id: string, params: organizationI) {
    return this.http.put(
      `${environment.apiUrl}/secretarias-organization/${id}`,
      params,
      { headers: this.getHeaders() }
    );
  }

  public delete(id: string) {
    return this.http.delete(
      `${environment.apiUrl}/secretarias-organization/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public show(id: string) {
    return this.http.get<Organization>(
      `${environment.apiUrl}/secretarias-organization/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-organization`, {
      headers: this.getHeaders(),
    });
  }
}
